import { put, takeLeading } from 'redux-saga/effects';

import invoiceApi from 'api/invoice';
import { apiErrorHandler, showSuccess } from 'utils';

import * as Actions from './actions';
import * as ActionTypes from './actionTypes';

function* getInvoices({ payload }) {
  try {
    const data = yield invoiceApi.getListInvoices(payload);

    yield put(Actions.getInvoicesSuccess(data.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(Actions.getInvoicesFailed());
  }
}

function* getGlobalInvoices({ payload }) {
  try {
    const data = yield invoiceApi.getGlobalInvoices(payload);

    yield put(Actions.getGlobalInvoicesSuccess(data.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(Actions.getGlobalInvoicesFailed());
  }
}

function* getGlobalInvoiceDetail({ payload }) {
  try {
    const data = yield invoiceApi.getGlobalInvoiceDetail(payload);

    yield put(Actions.getGlobalInvoiceDetailSuccess(data.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(Actions.getGlobalInvoiceDetailFailed());
  }
}

function* getInvoiceDetail({ payload }) {
  try {
    const data = yield invoiceApi.getInvoicesDetail(payload);

    yield put(Actions.getInvoiceDetailSuccess(data.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(Actions.getInvoiceDetailFailed());
  }
}

function* payInvoice({ payload }) {
  try {
    const data = yield invoiceApi.payInvoice(payload);

    if (payload && typeof payload.callback === 'function') {
      payload.callback(data);
    }
    showSuccess('Cập nhật trạng thái thanh toán thành công');
    yield put(Actions.payInvoiceSuccess(data.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(Actions.payInvoiceFailed());
  }
}

function* exportInvoice({ payload }) {
  try {
    const data = yield invoiceApi.exportInvoice(payload);

    if (payload && typeof payload.callback === 'function') {
      payload.callback(data);
    }
    yield put(Actions.exportInvoiceSuccess(data));
  } catch (error) {
    apiErrorHandler(error);

    yield put(Actions.exportInvoiceFailed());
  }
}

export default function* invoice() {
  yield takeLeading(ActionTypes.GET_INVOICES, getInvoices);
  yield takeLeading(ActionTypes.GET_GLOBAL_INVOICES, getGlobalInvoices);
  yield takeLeading(ActionTypes.GET_GLOBAL_INVOICE_DETAIL, getGlobalInvoiceDetail);
  yield takeLeading(ActionTypes.GET_INVOICE_DETAIL, getInvoiceDetail);
  yield takeLeading(ActionTypes.PAY_INVOICE, payInvoice);
  yield takeLeading(ActionTypes.EXPORT_INVOICE, exportInvoice);
}
